// Libraries
var React = require('react');

// Components
var OptaWidget = require('../OptaWidget/OptaWidget');

// Styles
require('./MatchPassMatrix.scss');

class MatchPassMatrixModule extends React.Component {
    
	render() {
        return (
            <div className="MatchPassMatrix">
                <h2>Pass Matrix</h2>
                <OptaWidget language={this.props.data.language} timezone={this.props.data.timezone} subscriptionId={this.props.data.subscriptionId} properties={this.props.data.properties}/>
            </div>)
    }
}
    
module.exports = MatchPassMatrixModule;


// WEBPACK FOOTER //
// ./src/components/MDC/MatchPassMatrix/MatchPassMatrixModule.js